// Import shared
require('./shared')

// Import widgets
require('../../widgets/search/main')
require('../../widgets/product-map/main')

require('../../../js/core/widget/widget-api')
